// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTableCell-root.table-headers__sort {
    cursor: pointer;
    background-color: var(--new-background-color);
    color: var(--basic-gray-color);    
    font-family: var( --secondary-font );
    font-style: normal;
    font-weight: var( --font-medium );
    font-size: calc( var( --space-half-quarter ) + var( --space-eighth ) + 1px );
    line-height: calc( var( --space ) + var( --space-eighth ) + 1px );
    align-items: center;
    letter-spacing: 0.0025em;
    padding: var( --space-half-quarter ) var( --space );
    border-bottom: 0;
}

.MuiTableCell-root.table-headers__sort:first-child{
    border-radius: 8px 0 0 8px;
}

.MuiTableCell-root.table-headers__sort:last-child{
    border-radius: 0 8px 8px 0;
}

.MuiTableCell-root.table-headers__no-sort {
    border-bottom: 0;
}

.table-headers__no-sort {    
    background-color: var(--new-background-color) !important;
    color: var(--basic-gray-color) !important;
}

.table-headers__no-sort:first-of-type {
    border-radius: var( --space-half ) 0 0 var( --space-half );
}

.table-headers__no-sort:last-of-type {
    border-radius: 0 var( --space-half ) var( --space-half ) 0;
}

.table-cell {
    /* background: var( --white-color ) !important; */
    color: var(--primary-dark-color) !important;
    font-family: var( --secondary-font ) !important;
    font-style: normal;
    font-weight: normal !important;
    font-size:  var( --space ) !important;
    line-height: calc( var( --space ) + var( --space-eighth ) + 1px ) !important;
    letter-spacing: 0.0025em;
    border-bottom: 0 !important;
    padding: var( --space ) var( --space-half-quarter ) !important;
}

.table-cell .icon-ball {
    color: var( --white-color );
    font-size: var( --space );
    border-radius: 50%;
    padding: var( --space-quarter );
}

.table-cell img{
    border-radius: 50%;
    width: var( --space-and-half );
    height: var( --space-and-half );
}

.table-row-image {
    height: var(--space-and-half);
    width: var(--space-and-half);
}
  
.add { 
  grid-area: add; 
  justify-content: flex-end;
}

.table-dynamic-container {
    z-index: -1;
}

.table-body__empty-table-msg {
    text-align: center;
    margin-top: calc( var(--space-x2) * 2);
}

.table-body__empty-table-msg p.baloa-body-1 {
    display: block;
    margin-top: var(--space);
}

.table-cell__end-match {
    display: flex;
    justify-content: flex-end;
}

.team-vs-team__photos__vs.baloa-username {
    color: var(--primary-dark-color);
    font-weight: var( --font-medium );
}

.MuiTableContainer-root.table-component__table-container {
    overflow-x: initial;
}

.component__table .column-tag{
    padding: 4px 6px;
    border-radius: 25px;
    color: var(--white-color);
    width: fit-content;
}

.component__table .column-tag.registered{
    background: var(--new-green-color);
}

.component__table .column-tag.no_registered{
    background: var(--basic-gray-color);
}

.component__table .column-tag.pre_registered{
    background: var(--new-yellow-color);
}

.table-row-menu-options{
    background: var(--white-color);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    width: 200px;
    position: absolute;
    top: 20px;
    right: 30px;
    z-index: 1;
}

.table-row-menu-options .hide{
    display: none;
}

.table-row-menu-options__icon{
    cursor: pointer;
    color: var(--primary-very-dark-color);
}

.table-option-buttons{
    position: relative;
}

.table-row:hover{
    background-color: var(--new-background-color);
}

.table-cell.link{
    cursor: pointer;
}

.table-row.link{
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/dynamic-table/TableComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,6CAA6C;IAC7C,8BAA8B;IAC9B,oCAAoC;IACpC,kBAAkB;IAClB,iCAAiC;IACjC,4EAA4E;IAC5E,iEAAiE;IACjE,mBAAmB;IACnB,wBAAwB;IACxB,mDAAmD;IACnD,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wDAAwD;IACxD,yCAAyC;AAC7C;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,iDAAiD;IACjD,2CAA2C;IAC3C,+CAA+C;IAC/C,kBAAkB;IAClB,8BAA8B;IAC9B,qCAAqC;IACrC,4EAA4E;IAC5E,wBAAwB;IACxB,2BAA2B;IAC3B,8DAA8D;AAClE;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;IAC9B,2CAA2C;IAC3C,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".MuiTableCell-root.table-headers__sort {\n    cursor: pointer;\n    background-color: var(--new-background-color);\n    color: var(--basic-gray-color);    \n    font-family: var( --secondary-font );\n    font-style: normal;\n    font-weight: var( --font-medium );\n    font-size: calc( var( --space-half-quarter ) + var( --space-eighth ) + 1px );\n    line-height: calc( var( --space ) + var( --space-eighth ) + 1px );\n    align-items: center;\n    letter-spacing: 0.0025em;\n    padding: var( --space-half-quarter ) var( --space );\n    border-bottom: 0;\n}\n\n.MuiTableCell-root.table-headers__sort:first-child{\n    border-radius: 8px 0 0 8px;\n}\n\n.MuiTableCell-root.table-headers__sort:last-child{\n    border-radius: 0 8px 8px 0;\n}\n\n.MuiTableCell-root.table-headers__no-sort {\n    border-bottom: 0;\n}\n\n.table-headers__no-sort {    \n    background-color: var(--new-background-color) !important;\n    color: var(--basic-gray-color) !important;\n}\n\n.table-headers__no-sort:first-of-type {\n    border-radius: var( --space-half ) 0 0 var( --space-half );\n}\n\n.table-headers__no-sort:last-of-type {\n    border-radius: 0 var( --space-half ) var( --space-half ) 0;\n}\n\n.table-cell {\n    /* background: var( --white-color ) !important; */\n    color: var(--primary-dark-color) !important;\n    font-family: var( --secondary-font ) !important;\n    font-style: normal;\n    font-weight: normal !important;\n    font-size:  var( --space ) !important;\n    line-height: calc( var( --space ) + var( --space-eighth ) + 1px ) !important;\n    letter-spacing: 0.0025em;\n    border-bottom: 0 !important;\n    padding: var( --space ) var( --space-half-quarter ) !important;\n}\n\n.table-cell .icon-ball {\n    color: var( --white-color );\n    font-size: var( --space );\n    border-radius: 50%;\n    padding: var( --space-quarter );\n}\n\n.table-cell img{\n    border-radius: 50%;\n    width: var( --space-and-half );\n    height: var( --space-and-half );\n}\n\n.table-row-image {\n    height: var(--space-and-half);\n    width: var(--space-and-half);\n}\n  \n.add { \n  grid-area: add; \n  justify-content: flex-end;\n}\n\n.table-dynamic-container {\n    z-index: -1;\n}\n\n.table-body__empty-table-msg {\n    text-align: center;\n    margin-top: calc( var(--space-x2) * 2);\n}\n\n.table-body__empty-table-msg p.baloa-body-1 {\n    display: block;\n    margin-top: var(--space);\n}\n\n.table-cell__end-match {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.team-vs-team__photos__vs.baloa-username {\n    color: var(--primary-dark-color);\n    font-weight: var( --font-medium );\n}\n\n.MuiTableContainer-root.table-component__table-container {\n    overflow-x: initial;\n}\n\n.component__table .column-tag{\n    padding: 4px 6px;\n    border-radius: 25px;\n    color: var(--white-color);\n    width: fit-content;\n}\n\n.component__table .column-tag.registered{\n    background: var(--new-green-color);\n}\n\n.component__table .column-tag.no_registered{\n    background: var(--basic-gray-color);\n}\n\n.component__table .column-tag.pre_registered{\n    background: var(--new-yellow-color);\n}\n\n.table-row-menu-options{\n    background: var(--white-color);\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 8px;\n    width: 200px;\n    position: absolute;\n    top: 20px;\n    right: 30px;\n    z-index: 1;\n}\n\n.table-row-menu-options .hide{\n    display: none;\n}\n\n.table-row-menu-options__icon{\n    cursor: pointer;\n    color: var(--primary-very-dark-color);\n}\n\n.table-option-buttons{\n    position: relative;\n}\n\n.table-row:hover{\n    background-color: var(--new-background-color);\n}\n\n.table-cell.link{\n    cursor: pointer;\n}\n\n.table-row.link{\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
